"use server";

import { z } from "zod";
import { redirect } from "next/navigation";
import { prisma } from "@/lib/prisma";
import { verifyPassword } from "@/lib/auth/password";
import { createSession } from "@/lib/auth/session";
import { resolveHomePath } from "@/lib/authz";

const loginSchema = z.object({
  email: z.email("Informe um e-mail valido."),
  senha: z.string().min(1, "Informe a senha."),
});

export type LoginState = { error?: string };

export async function loginAction(_prevState: LoginState, formData: FormData): Promise<LoginState> {
  const parsed = loginSchema.safeParse({
    email: formData.get("email"),
    senha: formData.get("senha"),
  });

  if (!parsed.success) {
    return { error: parsed.error.issues[0]?.message ?? "Dados invalidos." };
  }

  const { email, senha } = parsed.data;

  const user = await prisma.user.findUnique({ where: { email } });
  if (!user || user.role === "CLIENTE") {
    // Login de Cliente acontece em /conta/login, nao aqui.
    return { error: "E-mail ou senha invalidos." };
  }

  if (user.status !== "ATIVO") {
    return { error: "Este usuario esta bloqueado. Contate o administrador." };
  }

  const senhaValida = await verifyPassword(user.senhaHash, senha);
  if (!senhaValida) {
    return { error: "E-mail ou senha invalidos." };
  }

  await createSession(user);
  await prisma.user.update({ where: { id: user.id }, data: { ultimoLoginAt: new Date() } });

  const destino = await resolveHomePath({
    userId: user.id,
    role: user.role,
    revendaId: user.revendaId,
    empresaId: user.empresaId,
    impersonatingBy: null,
    permissions: new Set(),
  });

  redirect(destino);
}
